import inSection from "./in-section.util";

export const COLLECTIONS_DESTINATIONS = inSection("/collections", [
  { to: "outreach", label: "Outreach Schedule" },
  { to: "settings", label: "Settings" }
]);
